/* src/app/system-utils/actions-buttons/actions-buttons.component.scss */
.action-list {
  height: 100%;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: end;
  padding-bottom: 8px;
  align-items: center;
}
.divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid var(--tem-border);
}
.varbutton {
  margin-right: 1vw !important;
  font-size: 100% !important;
}
/*# sourceMappingURL=actions-buttons.component.css.map */
